<script>
  import members from './stores/MemberStore.js';
  export let visible = true;
  export let member;
  export let app;
  let error;
  let pendingDeletion;
  let acceptDeletion;

  const deleteMember = async () => {
    const res = await members.delete(app._id, member.user);
    if(!res.ok) error = res.body.message;
  }

</script>

{#if visible}
  <div class="tag is-light is-light mb-2">{member.role}</div>
  <div class="field is-grouped is-grouped-multiline">
    <div class="control is-expanded has-icons-right">
      <input class="input is-small" size=16 type="email" placeholder="E-mail" value={member.user} readonly>
      <span class="icon is-small is-right">
        <i class="fas fa-lock"></i>
      </span>
    </div>
    <div class="control">
      <button class="button is-small" type="button" on:click={() => pendingDeletion = true}>Remove</button>
    </div>
  </div>
  {#if pendingDeletion}
    <div class="mb-3">
      <label class="checkbox">
        <input class="mr-2" type="checkbox" bind:checked={acceptDeletion} on:click={() => acceptDeletion = !acceptDeletion}>
         I want to delete the user <strong>{member.user}</strong> with the role <strong>{member.role}</strong>.
      </label>
    </div>
    <div class="mb-5">
      <span class="tag is-danger" on:click={() => {if(acceptDeletion == true) deleteMember()}} on:keydown={() => {}}>Delete</span>
      <span class="tag is-light" on:click={() => {pendingDeletion = false; acceptDeletion = false}} on:keydown={() => {}}>Cancel</span>
    </div>
  {/if}
{/if}

{#if error}
<div class="columns">
  <div class="column">
    <div class="field">
      <!-- svelte-ignore a11y-label-has-associated-control -->
      <label class="label">Error</label>
      <div class="control">
        <textarea class="textarea is-danger" placeholder="Error" value={error}></textarea>
      </div>
    </div>
  </div>
</div>
{/if}

<style>
  button {
  width: 70px;
}
.tag {
  cursor: pointer;
}
</style>
